<div class="rental-manager-application">
    <div class="app-content content">
        <!--div class="sidebar-left" id="sidebar-left">
          <div class="sidebar">
            <div class="sidebar-content email-app-sidebar d-flex">
            
              <span class="sidebar-close-icon">
                <i class="ficon feather ft-x"></i>
              </span>
            
              <div class="email-app-menu">
                <div class=" bg-white text-center text-2xl" style="border-bottom: 1px solid #ddd; padding: 18px 0px; margin-top: 4px">Stammdaten</div>
                <div class="" fxFlex="auto" [perfectScrollbar]="config">
                    <ul class="media-list">
                        <li *ngIf="checkPermission('menu.settings')" class="p-1 border-b-2 cursor-pointer bg-white" [routerLink]="['./settings-manager']">Einstellungen</li>
                        <li *ngIf="checkPermission('menu.users')" class="p-1 border-b-2 cursor-pointer bg-white" [routerLink]="['./user-manager']">Benutzer</li>
                        <li *ngIf="checkPermission('menu.roles')" class="p-1 border-b-2 cursor-pointer bg-white" [routerLink]="['./role-manager']" >Rollen & Rechte</li>
                        <li  class="p-1 border-b-2 cursor-pointer  bg-white" [routerLink]="['./molpath']">Molekularpathologie</li>
                        <li  class="p-1 border-b-2 cursor-pointer  bg-blue-600 text-white" [routerLink]="['./skill-manager']">TEST Kalkulation Molpath</li>
                        
                        <li *ngIf="checkPermission('menu.mobile_app')"class="p-1 border-b-2 cursor-pointer bg-white" [routerLink]="['./skill-manager']">Mobile - APP</li>
                    </ul>    
                </div>
              </div>
            </div>

    
        </div>
        </div-->
    
        <div class="_content-right bg-white">
            <div class="content-header row">
            </div>
            <div class="content-overlay"></div>
            <div class="content-wrapper">
                <div class="content-body"  [perfectScrollbar]="config">
                    <router-outlet></router-outlet>
                </div>
            </div>
          </div>
    </div>  
    </div>      